import { Component, Directive, ViewContainerRef } from "@angular/core";
import { BaseDataModelServiceComponent } from "./base-data-model-service.component";
/**
 * This class can be used in case of standoline component which do not emit the data
 */
@Directive()
export abstract class BaseDataServiceComponent extends BaseDataModelServiceComponent{

    constructor(public viewContainerRef: ViewContainerRef) { super(); }

    getParentComponent(): Component {
        try {
            return this.viewContainerRef["_data"].componentView.component
                .viewContainerRef["_view"].component;
        } catch (error) {
            console.error(`Error while getting parent component ${error}`);
        }
    }

    getParentComponentName(): String {
        try {
            return this.viewContainerRef["_data"].componentView.component
                .viewContainerRef["_view"].component.constructor.name;
        } catch (error) {
            console.error(`Error while getting parent component name ${error}`);
        }
    }

    public abstract getCurrentComponentName();

}